<template>
  <div class="news-item" v-observe-visibility="{ callback: animate, once: true }">
    <div class="news-item-inner">
      <div class="news-item-content">
        <!-- <h3 class="title">{{ newsItem.title }}</h3> -->
        <div class="content">
          <p v-html="newsItem.content"></p>
        </div>
        <div class="meta">
          <div class="date">
            {{ formattedDate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'newsItem',
  data() {
    return {
      api_url: process.env.VUE_APP_STRAPI_API_URL,
    };
  },
  props: {
    newsItem: {
      type: Object,
    },
  },
  computed: {
    formattedDate() {
      let months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
      let date = new Date(this.newsItem.updated_at)
      console.log(date, date.getMonth(), date.getDay());
      return `${date.getDate()}. ${months[date.getMonth()]} ${date.getFullYear()}`
    }
  },
  methods: {
    animate(isVisible, entry) {
      if (isVisible) {
        entry.target.classList.add('animate__animated', 'animate__fadeInUp');
      }
    },
  },
};
</script>
